import React, { useState, useEffect } from "react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "components/Common/Breadcrumb";
import DashboardLoader from "components/Loader/DashboardLoader";
import { menuApiService } from "services/menuApiService";
// import { categoryApiService } from "services/categoryApiService";

const CreateMenuItem = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [categories, setCategories] = useState([]);
  const [imagePreview, setImagePreview] = useState("");

  const [formData, setFormData] = useState({
    item_name: "",
    description: "",
    category: "",
    price: "",
    discount: "",
    vat: "",
    quantity: "",
    productbrand: "",
    size: "",
    origin: "",
    image1: null,
  });

  // Fetch categories on component mount
  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      // Try to get categories from category API if available
      // Otherwise, get from menu items
      try {
        const catData = await menuApiService.getAllCategories();
        console.log("catData", catData);

        setCategories(catData);
      } catch (error) {
        // Fallback: get categories from menu items
        const products = await menuApiService.getAllProducts();
        const uniqueCategories = [...new Set(products.map(item => item.category))];
        setCategories(uniqueCategories.filter(cat => cat).map(cat => ({
          name: cat,
          id: cat
        })));
      }
    } catch (error) {
      // toast.error("Failed to load categories");
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        image1: file
      }));

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    // Validation
    if (!formData.item_name || !formData.category || !formData.price) {
      toast.error("Please fill in all required fields");
      setSubmitting(false);
      return;
    }

    try {
      const dataToSend = new FormData();
      dataToSend.append('item_name', formData.item_name);
      dataToSend.append('description', formData.description);
      dataToSend.append('category', formData.category);
      dataToSend.append('price', formData.price);
      dataToSend.append('discount', formData.discount || '');
      dataToSend.append('vat', formData.vat || '');
      dataToSend.append('quantity', formData.quantity || '');
      dataToSend.append('productbrand', formData.productbrand || '');
      dataToSend.append('size', formData.size || '');
      dataToSend.append('origin', formData.origin || '');
      if (formData.image1) {
        dataToSend.append('image1', formData.image1);
      }

      await menuApiService.createProduct(dataToSend);

      toast.success("Product created successfully!");

      // Navigate back to products list after a short delay
      setTimeout(() => {
        navigate("/all-menu-items");
      }, 1500);

    } catch (error) {
      console.error('Error creating product:', error);
      toast.error("Failed to create product. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return <DashboardLoader />;
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumb title="Menu Items" breadcrumbItem="Create Menu Item" />

        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title mb-4">Create New Product</h4>

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    {/* Left Column */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Item Name *</label>
                        <input
                          type="text"
                          className="form-control"
                          name="item_name"
                          value={formData.item_name}
                          onChange={handleChange}
                          required
                          placeholder="Enter item name"
                        />
                      </div>

                      <div className="col-md-12 mb-3">
                        <label className="form-label">Discount (%)</label>
                        <input
                          type="number"
                          className="form-control"
                          name="discount"
                          value={formData.discount}
                          onChange={handleChange}
                          min="0"
                          max="100"
                          placeholder="0"
                        />
                      </div>



                      <div className="row">



                      </div>

                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <label className="form-label">VAT (%)</label>
                          <input
                            type="number"
                            className="form-control"
                            name="vat"
                            value={formData.vat}
                            onChange={handleChange}
                            min="0"
                            max="100"
                            placeholder="0"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Description</label>
                          <textarea
                            className="form-control"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            rows="4"
                            placeholder="Enter product description"
                          />
                        </div>


                        {/* <div className="col-md-6 mb-3">
                          <label className="form-label">Quantity</label>
                          <input
                            type="number"
                            className="form-control"
                            name="quantity"
                            value={formData.quantity}
                            onChange={handleChange}
                            min="0"
                            placeholder="0"
                          />
                        </div> */}
                      </div>
                    </div>

                    {/* Right Column */}
                    <div className="col-md-6">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Price ($) *</label>
                        <input
                          type="number"
                          className="form-control"
                          name="price"
                          value={formData.price}
                          onChange={handleChange}
                          required
                          min="0"
                          step="0.01"
                          placeholder="0.00"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Category *</label>
                        <select
                          className="form-select"
                          name="category"
                          value={formData.category}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Category</option>
                          {categories.map((category) => (
                            <option key={category.id || category.name} value={category.name}>
                              {category.name === 'appetizer' ? 'Appetizers' :
                                category.name === 'main course' ? 'Main Dish' :
                                  category.name === 'fast food' ? 'Sides / Extra' :
                                    category.name === 'dessert' ? 'Dessert' : category.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Product Image</label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={handleFileChange}
                          accept="image/*"
                        />

                        {imagePreview && (
                          <div className="mt-3">
                            <p className="mb-1">Image Preview:</p>
                            <img
                              src={imagePreview}
                              alt="Preview"
                              style={{
                                width: '150px',
                                height: '150px',
                                objectFit: 'cover',
                                borderRadius: '8px',
                                border: '1px solid #ddd',
                              }}
                            />
                          </div>
                        )}
                      </div>

                      {/* <div className="mb-3">
                        <label className="form-label">Brand</label>
                        <input
                          type="text"
                          className="form-control"
                          name="productbrand"
                          value={formData.productbrand}
                          onChange={handleChange}
                          placeholder="Enter brand name"
                        />
                      </div> */}

                      {/* <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Size</label>
                          <input
                            type="text"
                            className="form-control"
                            name="size"
                            value={formData.size}
                            onChange={handleChange}
                            placeholder="e.g., Medium, Large"
                          />
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="form-label">Origin</label>
                          <input
                            type="text"
                            className="form-control"
                            name="origin"
                            value={formData.origin}
                            onChange={handleChange}
                            placeholder="e.g., Italy, USA"
                          />
                        </div>
                      </div> */}


                    </div>
                  </div>

                  <div className="mt-4">
                    <div className="d-flex justify-content-between">
                      {/* <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => navigate("/all-menu-items")}
                        disabled={submitting}
                      >
                        <i className="fas fa-arrow-left me-1"></i> Back to Products
                      </button> */}

                      <button
                        type="submit"
                        className="btn btn-success"
                        disabled={submitting}
                      >
                        {submitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-1"></span>
                            Creating...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-plus me-1"></i> Create Product
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateMenuItem;